






















import {
    Component,
    Vue,
    Prop,
    Watch
} from "vue-property-decorator";
import {
    State,
    Action,
    Getter,
    Mutation
} from "vuex-class";
import {
    pageDataType,
    CampaignPageDataType
} from "../types";
import {
    HOST,
    API_URL
} from "../global";
import {
    FETCH_CAMPAIGN_DATA
} from "../store/actions.names";
import {
    SET_CAMPAIGN_CURRENT_PAGE,
    SET_CAMPAIGN_DATA,
    CURRENT_PAGE_ERROR,
    SET_CAMPAIGN_PARENT_PAGE
} from "../store/mutations.names";
import axios from "axios";
import {
    TimelineMax,
    Power1,
    Expo,
    Power2,
    Power4
} from "gsap";
import BannerTextBlock from "../components/BannerTextBlock.vue";
import CampaignCard from "../components/CampaignCard.vue";

@Component({
    name: 'CampaignIndexPage',
    components: {
        banner: BannerTextBlock,
        campaign_block: CampaignCard
        // BannerText,
        // CampaignLCards,
        // CampaignRCards,
        // Footer,
    },
})
export default class CampaignIndexPage extends Vue {
    @Getter("campaignData") public campaignData!: CampaignPageDataType[];
    @Prop() public pageData!: pageDataType;
    @Getter("pageType") public pageType!: string | null;
    @Action(FETCH_CAMPAIGN_DATA) public fetchData: any;
    @Mutation(SET_CAMPAIGN_CURRENT_PAGE) public[SET_CAMPAIGN_CURRENT_PAGE]: any;
    // @Getter("campaignData") public pages!: CampaignPageDataType[];
    public HOST: string = HOST;

    public mounted() {
        this.fetchData(this.pageData.id);
        // console.log(this.campaignData);
    }

    get otherCampaigns() {
        const selectedCampaigns = this.pageData.body.filter((val: any, index: number) => {
            return val.type == "campaign_block"
        }).map((val: any, idx: number) => {
            return val.value.call_to_action.id
        });
        return this.campaignData.filter((val, idx) => {
            return selectedCampaigns.indexOf(val.id) == -1;
        })
    }

}
